exports = module.exports = require("../../../../node_modules/_css-loader@0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.vvc-menu-bar {\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  -webkit-user-select: none;\n  user-select: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.26.4@css-loader!./~/_vue-loader@10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-5f5ee914!./~/_sass-loader@6.0.6@sass-loader/lib/loader.js!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/tofu-menu/src/menu.vue
// module id = 463
// module chunks = 0